__webpack_require__.p = "http://mot.softebytes.com/";